import isEmpty from 'lodash/isEmpty'
import moment from 'moment'

import { smartWeekendFilter } from './smartWeekend'

export function _processCalendarPricing(
  unfilteredCalendarPricing,
  isOW,
  requestObj
) {
  let processedCalendarPricing = unfilteredCalendarPricing
  if (!isOW) {
    processedCalendarPricing = unfilteredCalendarPricing
      .filter(itin => {
        if (isEmpty(itin)) {
          return false
        }
        return smartWeekendFilter(itin, requestObj)
      })
      .sort((a, b) => {
        return a.fare - b.fare
      })
  }

  return processedCalendarPricing
}

export function _shouldCallElasticSearch(apWindow, isRT) {
  return !(apWindow <= 1 && isRT)
}

// TODO Is this logic equivalant to _isValidResult? Try to combine
export function _isValidSOPQResult(record, requestObj) {
  return !(
    record.isSameDate ||
    record.origin1 !== requestObj.slices[0].originAirport ||
    record.destination1 !== requestObj.slices[0].destinationAirport
  )
}

export function _mapRequestParamsToRecord(record, params) {
  record.numYouth = 0

  if (params) {
    if (params['num-adults']) {
      record.numAdult = parseInt(params['num-adults'])
    }
    if (params['num-youths']) {
      record.numYouth = parseInt(params['num-youths'])
    }
    if (params['num-children']) {
      record.numChild = parseInt(params['num-children'])
    }
    if (params['num-infants']) {
      record.numInfant = parseInt(params['num-infants'])
    }
  }

  return record
}

// Needed only for Angular
export function isFlexDatesTiles(calendarPricing, travelDate, tripType) {
  return (
    tripType === 'OW' &&
    calendarPricing instanceof Array &&
    calendarPricing.length > 0 &&
    !!travelDate &&
    moment(travelDate).isValid()
  )
}
